export default {"src":"/_next/static/media/JnK.6db913bf.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};